import {useMemo} from 'react';
import {useWorkstream} from 'views/workstreams/hooks';
import {isRestrictedWorkstreamAccessResponse} from 'views/workstreams/utils';
import {WorkstreamAccessRequest} from 'views/workstreams/WorkstreamAccessRequest';

import {isArchived, WorkstreamScanList} from './WorkstreamScanList';
import {WorkstreamLoadFailure} from './WorkstreamsControls';

/**
 * /workstreams/:id: what a rail click on a workstream with
 * sub-workstreams shows (a pillar of one such workstream too: Multi-Product,
 * Tech, GTM…). Its own card, collapsed like any in a list, then its
 * sub-workstreams as the same cards a pillar of side-by-side workstreams
 * (Applications) lists, so they aren't buried under its full update.
 */
export const ParentWorkstreamView = ({
  workstreamId,
  onLeaveUpdate,
}: {
  workstreamId: number;
  onLeaveUpdate: (id: number) => void;
}) => {
  const {workstream, isLoading, error, refetch} = useWorkstream(workstreamId);
  const sections = useMemo(() => {
    // Saved order, as the API returns them.
    const subs = (workstream?.dependencies ?? []).map(({dependent}) => dependent);
    return [
      {
        key: 'subworkstreams',
        label: 'Sub-workstreams',
        workstreams: subs.filter((sub) => !isArchived(sub)),
        archived: subs.filter(isArchived),
      },
    ];
  }, [workstream?.dependencies]);

  if (isRestrictedWorkstreamAccessResponse(workstream as never)) {
    return (
      <WorkstreamAccessRequest
        requested={(workstream as {requested?: boolean | null}).requested ?? false}
        workstreamId={workstreamId}
      />
    );
  }
  if (!isLoading && !workstream) {
    return <WorkstreamLoadFailure error={error} onRetry={() => void refetch()} />;
  }

  return (
    <WorkstreamScanList
      workstreams={[]}
      parent={workstream}
      sections={sections}
      loading={isLoading && !workstream}
      skeleton="parent"
      onLeaveUpdate={onLeaveUpdate}
    />
  );
};
